import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { IconPlus } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { toast } from '@/components/toasts/toast.helpers'
import { findTestCall } from '@/reducers/prompts/prompts.actions'

const ADD_TEST_BUTTONS = [
  { expectedScore: 'yes', label: 'Passing' },
  { expectedScore: 'no', label: 'Failing' },
  { expectedScore: 'n/a', label: 'N/A' },
]

/**
 * Buttons for adding test cases by finding calls with specific scores
 */
export const AddTestCaseForm = ({
  onAddTestCase,
  criteriaScid,
  organizationId,
  existingCallIds = [],
}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState({})

  const isAnyLoading = ADD_TEST_BUTTONS.some(({ expectedScore }) => loading[expectedScore])

  const handleFindCall = async (expectedScore) => {
    if (!criteriaScid) {
      toast.error('No criteria SCID available')
      return
    }

    setLoading((prev) => ({ ...prev, [expectedScore]: true }))

    try {
      const result = await dispatch(
        findTestCall(criteriaScid, expectedScore, organizationId, existingCallIds)
      )

      if (result?.call_id) {
        onAddTestCase({
          callId: result.call_id,
          expectedResult: expectedScore,
          callType: result.call_type || 'call',
        })
        toast.success(`Found ${expectedScore} call: ${result.call_id}`)
      }
    } catch (error) {
      if (error.status === 404) {
        toast.error(`No ${expectedScore} calls found for this criteria`, { cause: error })
      } else {
        toast.error(`Failed to find ${expectedScore} call`, { cause: error })
      }
    } finally {
      setLoading((prev) => ({ ...prev, [expectedScore]: false }))
    }
  }

  return (
    <div className="add-test-case-card">
      <div className="add-test-case-label">Find and add test call</div>
      <div className="add-test-case-buttons">
        {ADD_TEST_BUTTONS.map(({ expectedScore, label }) => (
          <Button
            key={expectedScore}
            basic
            small
            onClick={() => handleFindCall(expectedScore)}
            loading={loading[expectedScore]}
            disabled={isAnyLoading || !criteriaScid}
          >
            <IconPlus /> {label}
          </Button>
        ))}
      </div>
    </div>
  )
}
